var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('preloader'),(_vm.isLanding)?_c('landing-page',{attrs:{"isAuthenticated":_vm.isAuthenticated}}):_c('pages',{attrs:{"isAuthenticated":_vm.isAuthenticated,"isFreelancer":_vm.isFreelancer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }